.base {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 0;
  height: 34px;
  padding: 0 10px;
  /* Single accent knob — override --ps-button-color from the className on this
     element to re-theme icon, label, border and glow at once (all currentColor). */
  color: var(--ps-button-color, var(--ps-gold));
  background: var(--ps-bg-elevated);
  border: 1px solid var(--ps-border-default);
  border-radius: var(--ps-radius-pill);
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  font-family: var(--ps-font-sans);
  transition: all 0.3s var(--ps-ease-default);
}

.base:hover {
  gap: 8px;
  padding: 0 14px;
  border-color: currentColor;
  background: color-mix(in srgb, currentColor 10%, var(--ps-bg-elevated));
  box-shadow: 0 0 16px color-mix(in srgb, currentColor 25%, transparent);
}

.base svg {
  flex-shrink: 0;
  transition: transform 0.3s ease;
  animation: pulseGlow 3s ease-in-out infinite;
}

.base:hover svg {
  transform: scale(1.15);
  animation: none;
}

@keyframes pulseGlow {
  0%,
  100% {
    opacity: 0.85;
    filter: drop-shadow(0 0 0 transparent);
  }
  50% {
    opacity: 1;
    filter: drop-shadow(0 0 4px color-mix(in srgb, currentColor 50%, transparent));
  }
}

.label {
  max-width: 0;
  opacity: 0;
  font-size: var(--ps-text-sm);
  font-weight: 600;
  letter-spacing: 0.02em;
  transition:
    max-width 0.3s var(--ps-ease-default),
    opacity 0.25s ease 0.05s;
}

.base:hover .label {
  max-width: 140px;
  opacity: 1;
}
